import { Component, Input, OnInit } from '@angular/core'; '../analytics.service';
export interface LegendItem{
    color: string;
    label: string;
    sublabel: string;
}
@Component({
    selector: 'google-chart-legend',
    template: `
    <div class="legend-container">
        <div *ngFor="let item of legend" class="legend-item">
            <div class="legend-item-color" [style.backgroundColor]="item.color"></div>
            <div class="legend-item-label"><span class="bold">{{ item.label }}</span>{{ item.sublabel }}</div>
        </div>
    </div>
    
  `,
    styles: [
        `
        .legend-container {
            display: flex;
            margin-top: 8px;
        }
        .legend-item {
            display: flex;
            align-items: center;
            margin-right: 32px;
        }
        .legend-item-color {
            width: 20px;
            height: 20px;
            margin-right: 8px;
        }
        .bold {
            font-weight: bold;
        }
    `
    ]
})
export class GoogleChartLegendComponent implements OnInit {
    @Input() legend: LegendItem[];
    constructor(
    ) {

    }
    ngOnInit(): void {
    }
}
